import { render } from "./RightSideBarComponent.vue?vue&type=template&id=1cb2d7f4&scoped=true"
import script from "./RightSideBarComponent.vue?vue&type=script&lang=js"
export * from "./RightSideBarComponent.vue?vue&type=script&lang=js"

import "./RightSideBarComponent.vue?vue&type=style&index=0&id=1cb2d7f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb2d7f4"]])

export default __exports__